import { USECASE } from "../../model/usecase.model";

export class setDefaultGlobal {
  static readonly type = "[Global] set default Global state";
  constructor() {}
}
export class setPrimaryColor {
  static readonly type = "[Global] Update primary color";
  constructor(public payload: string) {}
}
export class setSecondaryColor {
  static readonly type = "[Global] Update secondary color";
  constructor(public payload: string) {}
}
export class setTertiaryColor {
  static readonly type = "[Global] Update tertiary color";
  constructor(public payload: string) {}
}
export class setBarcodeType {
  static readonly type = "[Global] Update barcode type";
  constructor(public payload: string) {}
}
export class setLanguage {
  static readonly type = "[Global] Update language";
  constructor(public payload: string) {}
}
export class setFaceUrl {
  static readonly type = "[Global] Set face url";
  constructor(public payload: string) {}
}
export class setBioSealUrl {
  static readonly type = "[Global] Set bioseal url";
  constructor(public payload: string) {}
}
export class setToken {
  static readonly type = "[Global] Set token";
  constructor(public payload: string) {}
}
export class setVerificationUrl {
  static readonly type = "[Global] Set verification url";
  constructor(public payload: string) {}
}
export class setPhotoDisplay {
  static readonly type = "[Global] Set photo display configuration";
  constructor(public payload: boolean) {}
}
export class setContentType {
  static readonly type = "[BioSeal] Update BioSeal Content type";
  constructor(public payload: boolean) {}
}
export class setConnectionFace {
  static readonly type = "[Face] Set facepad communication";
  constructor() {}
}
export class setConnectionBioSeal {
  static readonly type = "[BioSeal] Set bioseal communication";
  constructor() {}
}
export class restartSteps {
  static readonly type = "[Workflow] Start workflow steps";
  constructor() {}
}
export class incrementStep {
  static readonly type = "[Workflow] Increment workflow steps";
  constructor() {}
}
export class decrementStep {
  static readonly type = "[Workflow] Decrement workflow steps";
  constructor() {}
}
export class setSTEP {
  static readonly type = "[Workflow] set workflow step";
  constructor(public payload: any) {}
}
export class confirmBioSealPersonalContent {
  static readonly type = "[BioSeal] Confirm BioSeal personal content";
  constructor(public payload: boolean) {}
}
export class confirmBioSealDocumentContent {
  static readonly type = "[BioSeal] Confirm BioSeal document content";
  constructor(public payload: boolean) {}
}
export class setupUseCase {
  static readonly type = "[Workflow] Setup Use Case";
  constructor(public payload: USECASE) {}
}
